/* eslint-disable react/button-has-type */
/* eslint-disable linebreak-style */
import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Box from '@material-ui/core/Box';
import Rating from '@material-ui/lab/Rating';
import { useHistory, useParams } from 'react-router';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import { connect } from 'react-redux';
import { addReview, getAllReviews } from '../../network';

const WriteReview = ({ firstName, id, userId, setNewReview, auth }) => {
    const useStyles = makeStyles((theme) => ({
        paper: {
            position: 'absolute',
            width: 400,
            backgroundColor: theme.palette.background.paper,
            borderRadius: '12px',
            boxShadow: theme.shadows[5],
            padding: theme.spacing(3, 3, 3),
        },
    }));

    const classes = useStyles();
    const [modalStyle] = useState(getModalStyle);
    const [open, setOpen] = useState(false);
    const [comment, setComment] = useState('');
    const [rating, setRating] = useState(0);
    const history = useHistory();
   

    const handleOpen = () => {
        if (auth?.token) {
            setOpen(true);
        } else {
            history.push('/login');
        }
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleChange = (e) => {
        setComment(e.target.value);
        localStorage.setItem('comment', e.target.value);
    };

    const newReview = () => {
        const review = { product: id, customer: userId, comment, rating };
        addReview(review)
            .then(result => {
                setComment('');
                setRating('');
                setOpen(false);
                setNewReview(Date.now());
            })
            .catch(error => console.log(error));
    };

    const body = (
        <ModalContainer style={modalStyle} className={classes.paper}>
            <p className="modal-title"> {firstName}, How would you rate this product? </p>
            <div>
                <Rating
                    name="customized-empty"
                    precision={0.5}
                    size="large"
                    value={rating}
                    onChange={(event, newValue) => {
                        setRating(newValue);
                    }}
                    emptyIcon={<StarBorderIcon fontSize="inherit" />}
                />
            </div>
            <p className="modal-title"> Tell us about your experience using this product. </p>

            <ModalInput
                type="text"
                placeholder="This is where you write your review. Explain what happened. Keep your feedback honest, helpful, and constructive. Leave out any offensive words."
                value={comment}
                onChange={handleChange}
            />

            <div className="button-container">
                <button
                    className={comment.length > 0 ? 'blue-done-btn' : 'done-btn'}
                    onClick={() => newReview()}
                >
                    Done </button>
                <button className="cancel-btn" onClick={handleClose}> Cancel</button>
            </div>

        </ModalContainer>
    );

    return (
        <WriteReviewWrapper>
            <WriteReviewContainer>
                <p className="write-review-title"> Review This Product </p>

                <p> Share your experience using this product. </p>

                <WriteReviewBtn onClick={handleOpen}> Write a Review </WriteReviewBtn>

                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                >
                    {body}
                </Modal>
            </WriteReviewContainer>
        </WriteReviewWrapper>
    );
};

const mapStateToProps = state => ({
    auth: state.auth,
    user: state.user
});

export default connect(mapStateToProps, null)(WriteReview);

const WriteReviewWrapper = styled.div`
    width: 100%;
    height: 100%;
`;

const WriteReviewContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    
    width: 30rem;
    height: 10rem;
    margin-top: 4rem;

    background: #F7F7F7;

    .write-review-title{
        font-size: 20px;
        line-height: 20px;
        align-items: center;

        color: #000000;
    }

    .write-review-content{
        font-size: 14px;
        line-height: 14px;
        align-items: center;

        color: #000000;
    }
`;

const WriteReviewBtn = styled.button`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px 16px;

    width: 317px;
    height: 36px;

    background: #ED8936;
    border-radius: 4px;

    font-weight: 500;
    font-size: 16px;
    line-height: 16px;

    color: #FFFFFF;

    &:hover{
        background: #EB7A1E;
    }
`;

const ModalContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;

    padding: 5rem;

    width: 20rem;

    .modal-title{
        font-weight: normal;
        font-size: 16px;
        line-height: 16px;

        color: #000000;
    }

    .button-container{
        display: flex;
        justify-content: space-between;
    }

    .done-btn{
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 8px 12px;

        background: #D3D9DE;

        border-radius: 6px;
        width: 65px;
        height: 32px;

        color: #ffff;

        font-size: 16px;
        line-height: 16px;
    }

    .cancel-btn{
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 8px 12px;

        width: 77px;;
        height: 32px;

        border: 1px solid #525B64;
        box-sizing: border-box;
        border-radius: 6px;
        border: 1px solid #525B64;

        font-weight: 500;
        font-size: 16px;
        line-height: 16px;

        text-align: center;

        color: #525B64;
    }

    .blue-done-btn{
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 8px 12px;

        background: #049CBE;

        border-radius: 6px;
        width: 65px;
        height: 32px;

        color: #ffff;

        font-size: 16px;
        line-height: 16px;
    }
`;

const ModalInput = styled.textarea`
    background: #F6F8F8;
    padding: 13px;

    border: 1px solid #D3D9DE;
    border-radius: 8px;

    height: 92px;
    overflow: hidden;
    resize: none;

    font-weight: normal;
    font-size: 12px;
    line-height: 12px;

    &::placeholder{
    color: #8D9AA5;
    }
`;

function getModalStyle() {
    const top = 40;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
};